import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {connect} from "react-redux";
import {compose} from "recompose";
import {
    convertDate,
    toCurrency
} from '../shared/functions';
import {getGetHeaders} from '../shared/serverFunctions';
import {getTableState} from "../shared/tableFunctions";
import {RESOURCES as reportsResources} from '../fuseReportsResourceMap';
import CircularProgress from 'material-ui/CircularProgress';
import DialogSaleReceipt from './DialogSaleReceipt';
import DialogSaleSeq from './DialogSaleSeq';
import ReactToPrint from 'react-to-print';
import '../shared/react-table.css';
import {commonStyles} from '../shared/styles';
import {tableStyles} from '../shared/styles-table';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';

/**
 * Class for retrieving and displaying Sales Log Summary in a single table
 *
 */
class SalesLogDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            creditsList: [],
            discountsList: [],
            open: false,
            paymentsList: [],
            productList: [],
            productReturnedList: [],
            summaryTableData: [],
            transactionData: null
        };

        this.detailPosition = null;
        this.handleSortOrFilterChange = this.handleSortOrFilterChange.bind(this);
        this.processTransactionData = this.processTransactionData.bind(this);
    }

    componentWillMount() {
        if (this.props.sequence) {
            this.fetchTransactionData(this.props.sequence);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.sequence !== this.props.sequence) {
            this.setState({
                summaryTableData: [],
                transactionData: null
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.sequence && (prevProps.sequence !== this.props.sequence)) {
            this.fetchTransactionData(this.props.sequence);
        }
    }

    /**
     * Fetch Transaction Data
     * @param seq
     */
    fetchTransactionData(seq) {
        this.setState({
            open: true
        });
        let resource = reportsResources.SaleLogBySeq.GET_LIST(seq);

        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data && result.data.payload) {
                this.processTransactionData(result.data.payload);
            }
        }).catch((error) => {
            if (error.response) {
                // Server response outside 2xx
                console.log(error.response.data);
            } else if (error.request) {
                // No response
                console.log(error.request);
            } else {
                console.log('Error', error.message);
            }
        });
    }

    /**
     * Process Transaction Data
     * @param data
     */
    processTransactionData(data) {
        const emptyCurrency = toCurrency(0);
        let paymentsList = [];
        let creditsList = [];
        let productList = [];
        let productReturnedList = [];
        let discountsList = [];
        let divisor = 100;

        let details = data.hits.hits[0]._source.rxtxMsg.payload;
        let tDateString = (details.transaction_date)
            ? convertDate(details.transaction_date, 'display', true, true, this.props.offset, true)
            : 'No Date';

        if (details) {
            const detailRow = {
                dba_email: (details.location && details.location.dba) ? details.location.dba.email : '',
                dba_name: (details.location && details.location.dba) ? details.location.dba.name : '',
                device: (details.client.device) ? details.client.device : '----',
                initial_net: (details.initial_net) ? (toCurrency(details.initial_net / divisor)) : emptyCurrency,
                initial_tax: (details.initial_tax) ? (toCurrency(details.initial_tax / divisor)) : emptyCurrency,
                initial_additional_taxes: (details.initial_additional_taxes) ? (toCurrency(details.initial_additional_taxes / divisor)) : emptyCurrency,
                initial_total: (details.initial_total) ? (toCurrency(details.initial_total / divisor)) : emptyCurrency,
                location: (details.client.location) ? details.client.location : '----',
                location_address: (details.location.address) ? details.location.address : '',
                location_city: (details.location.city) ? details.location.city : '',
                location_telephone: (details.location.telephone) ? details.location.telephone : '',
                location_state: (details.location.state) ? details.location.state : '',
                location_tax_rate: (details.location.tax_rate) ? details.location.tax_rate.toString() : '0',
                location_zipcode: (details.location.zipcode) ? details.location.zipcode : '',
                loyalty_id: (details.loyalty_customer && details.loyalty_customer.id) ? details.loyalty_customer.id : '',
                register: (details.client.register) ? details.client.register : '----',
                user: (details.client.user) ? details.client.user : '----',
                version: (details.client.version) ? details.client.version : '----',
                mode: (details.mode) ? details.mode : '----',
                seq: (details.seq) ? details.seq : '----',
                transaction_date_string: tDateString,
            };

            if (details.payments) {
                let totalPayments = details.payments.length;
                for (let i = 0; i < totalPayments; i++) {
                    let paymentResult = details.payments[i];
                    const paymentRow = {
                        seq: (paymentResult.seq) ? paymentResult.seq : '----',
                        type: (paymentResult.type) ? paymentResult.type : '----',
                        card_type: (paymentResult.card_type) ? paymentResult.card_type : '----',
                        card_last4: (paymentResult.card_last4) ? paymentResult.card_last4 : '----',
                        card_data_source: (paymentResult.card_data_source) ? paymentResult.card_data_source : '----',
                        pn_ref: (paymentResult.pn_ref) ? paymentResult.pn_ref : '----',
                        authcode: (paymentResult.authcode) ? paymentResult.authcode : '----',
                        mode: (paymentResult.mode) ? paymentResult.mode : '----',
                        subtotal: (paymentResult.subtotal) ? (toCurrency(paymentResult.subtotal / divisor)) : emptyCurrency,
                        additional_taxes: (paymentResult.additional_taxes) ? paymentResult.additional_taxes : null,
                        additional_tax_total: (paymentResult.additional_tax_total) ? (toCurrency(paymentResult.additional_tax_total / divisor)) : emptyCurrency,
                        tax: (paymentResult.tax) ? (toCurrency(paymentResult.tax / divisor)) : emptyCurrency,
                        currency: (paymentResult.currency)
                            ? (paymentResult.type === 'loyalty_points')
                                ? (toCurrency(paymentResult.currency / 1000))
                                : (toCurrency(paymentResult.currency / divisor))
                            : emptyCurrency
                    };
                    paymentsList.push(paymentRow);
                }
                // Order payments: Loyalty Points, Cash, Credit
                const paymentSort = ['loyalty_points', 'cash', 'out_of_scope'];
                let paymentObj = {};
                paymentSort.forEach(function (a, i) {
                    paymentObj[a] = i + 1;
                });
                paymentsList.sort(function (a, b) {
                    return (paymentObj[a.type] || Infinity) - (paymentObj[b.type] || Infinity);
                });
                this.setState({
                    paymentsList: paymentsList
                });
            }

            if (details.credits) {
                let totalCredits = details.credits.length;
                for (let i = 0; i < totalCredits; i++) {
                    let creditResult = details.credits[i];
                    let tDateString = (creditResult.credit_date) ? convertDate(creditResult.credit_date, 'display', true, true, this.props.offset, true) : 'No Date';
                    const creditRow = {
                        seq: (creditResult.seq) ? creditResult.seq : '----',
                        payment_seq: (creditResult.payment_seq) ? creditResult.payment_seq : '----',
                        type: (creditResult.type) ? creditResult.type : '----',
                        credit_date: tDateString,
                        subtotal: (creditResult.subtotal) ? (toCurrency(creditResult.subtotal / divisor)) : emptyCurrency,
                        additional_tax_total: (creditResult.additional_tax_total) ? (toCurrency(creditResult.additional_tax_total / divisor)) : emptyCurrency,
                        tax: (creditResult.tax) ? (toCurrency(creditResult.tax / divisor)) : emptyCurrency,
                        currency: (creditResult.currency) ? (toCurrency(creditResult.currency / divisor)) : emptyCurrency,
                        card_type: (creditResult.card_type) ? creditResult.card_type : '----',
                        card_last4: (creditResult.card_last4) ? creditResult.card_last4 : '----',
                        card_data_source: (creditResult.card_data_source) ? creditResult.card_data_source : '----',
                        pn_ref: (creditResult.pn_ref) ? creditResult.pn_ref : '----',
                        authcode: (creditResult.authcode) ? creditResult.authcode : '----',
                        mode: (creditResult.mode) ? creditResult.mode : '----',
                        status: (creditResult.status) ? "True" : '----'

                    };
                    creditsList.push(creditRow);
                }
                this.setState({
                    creditsList: creditsList
                });
            }

            let discountTotal = 0;
            if (details.discounts) {
                let totalDiscounts = details.discounts.length;
                for (let i = 0; i < totalDiscounts; i++) {
                    let discountResult = details.discounts[i];
                    const discountRow = {
                        code: (discountResult.code) ? discountResult.code : '----',
                        name: (discountResult.name) ? discountResult.name : '----',
                        discount_each: (discountResult.discount_each) ? (toCurrency(discountResult.discount_each / divisor)) : emptyCurrency
                    };
                    discountsList.push(discountRow);
                    discountTotal += (discountResult.discount_each) ? parseInt(discountResult.discount_each, 10) : 0;
                }
                this.setState({
                    discountsList: discountsList
                });
            }

            if (details.product_units) {
                let totalProducts = details.product_units.length;
                for (let i = 0; i < totalProducts; i++) {
                    let productResult = details.product_units[i];
                    // Use Display Price until calculations are adjusted
                    let productQty = (productResult.qty) ? productResult.qty : 0;
                    let displayPrice = (productResult.display_price) ? productResult.display_price : 0;
                    let displaySubtotal = (displayPrice * productQty);
                    let salesTax = (productResult.price_tax_total) ? Number(productResult.price_tax_total) : 0;
                    let additionalTax = (productResult.price_additional_tax_total) ? Number(productResult.price_additional_tax_total) : 0;
                    let totalTax = salesTax + additionalTax;
                    const productRow = {
                        product_name: (productResult.product_name) ? productResult.product_name : '----',
                        product_unit_id: (productResult.product_unit_id) ? productResult.product_unit_id : '----',
                        product_unit_type: (productResult.product_unit_type) ? productResult.product_unit_type : '----',
                        qty: (productResult.qty) ? productResult.qty : '----',
                        price_each: (productResult.price_each) ? (toCurrency(productResult.price_each / divisor)) : emptyCurrency,
                        price_each_display: (displayPrice) ? toCurrency(displayPrice) : emptyCurrency,
                        price_subtotal: (productResult.price_subtotal) ? (toCurrency(productResult.price_subtotal / divisor)) : emptyCurrency,
                        price_subtotal_display: (displaySubtotal) ? toCurrency(displaySubtotal) : emptyCurrency,
                        price_tax_total: (totalTax) ? (toCurrency(totalTax / divisor)) : emptyCurrency,
                        price_total: (productResult.price_total) ? (toCurrency(productResult.price_total / divisor)) : emptyCurrency,
                    };
                    productList.push(productRow);
                }
                this.setState({
                    productList: productList
                });
            }

            if (details.product_units_returned) {
                let totalProductsReturned = details.product_units_returned.length;
                for (let i = 0; i < totalProductsReturned; i++) {
                    let productReturnedResult = details.product_units_returned[i];
                    const productReturnedRow = {
                        product_unit_id: (productReturnedResult.product_unit_id) ? productReturnedResult.product_unit_id : '----',
                        product_name: (productReturnedResult.product_name) ? productReturnedResult.product_name : '----',
                        product_unit_type: (productReturnedResult.product_unit_type) ? productReturnedResult.product_unit_type : '----',
                        qty: (productReturnedResult.qty) ? productReturnedResult.qty : '----',
                    };
                    productReturnedList.push(productReturnedRow);
                }
                this.setState({
                    productReturnedList: productReturnedList
                });
            }

            detailRow.discount_total = (discountTotal) ? (toCurrency(discountTotal / divisor)) : emptyCurrency;
            detailRow.discount_total_string = detailRow.discount_total;
            if (discountTotal < 0) {
                const discountAmount = discountTotal.toString().substr(1);
                detailRow.discount_total_string = '-$' + toCurrency(parseInt(discountAmount, 10) / 100);
            }
            this.setState({
                transactionData: detailRow
            }, () => {
                this.handleOpen();
            });
        }
    }

    /**
     * Update selected table data based on sort
     *
     * @param event
     * @param table
     */
    handleSortOrFilterChange(event, table) {
        const tableData = getTableState(table);
        if (tableData && tableData.length > 0) {
            this.setState({
                summaryTableData: tableData
            });
        }
    }

    /**
     * Open/Close Dialog
     */
    handleOpen = () => {
        this.setState({open: true});
    };

    handleClose = () => {
        this.setState({
            open: false,
            paymentsList: [],
            creditsList: [],
            productList: [],
            productReturnedList: [],
            discountsList: []
        }, () => {
            this.props.onCloseDialog();
        });
    };

    /* Table Display ------------------------------ */

    render() {
        const {
            includeReceipt
        } = this.props;

        const {
            transactionData,
            paymentsList,
            creditsList,
            productList,
            productReturnedList,
            discountsList
        } = this.state;

        // Dialog Actions
        const dialogActions = [
            <FlatButton
                label="Close"
                primary={true}
                onClick={this.handleClose}
            />
        ];

        return (
            <div>
                <Dialog
                    modal={false}
                    open={this.state.open}
                    onRequestClose={this.handleClose}
                    contentClassName={"dialogContentTable"}
                    actionsContainerClassName={"dialogPrintOnly"}
                    autoScrollBodyContent={true}
                    actions={dialogActions}
                >
                    <div style={tableStyles.flexContainerRight}>
                        {includeReceipt &&
                            <ReactToPrint
                                trigger={() =>
                                    <RaisedButton
                                        primary
                                        type="button"
                                        label="Print Receipt"
                                        style={tableStyles.printBtn}/>
                                }
                                content={() => this.printReceiptRef}
                            />
                        }
                        <ReactToPrint
                            trigger={() =>
                                <RaisedButton
                                    primary
                                    type="button"
                                    label="Print Report"
                                    style={tableStyles.printBtn}/>
                            }
                            content={() => this.printReportRef}
                        />
                    </div>
                    {!transactionData &&
                        <div style={commonStyles.loaderContainer}>
                            <h4>Assembling Sale Data...</h4>
                            <CircularProgress
                                size={24}
                                thickness={2}
                                style={commonStyles.loader}
                            />
                        </div>
                    }
                    {transactionData &&
                        <DialogSaleSeq
                            ref={e => (this.printReportRef = e)}
                            data={transactionData}
                            payments={paymentsList}
                            credits={creditsList}
                            products={productList}
                            returns={productReturnedList}
                            discounts={discountsList}
                            handleSortOrFilterChange={this.handleSortOrFilterChange}
                        />
                    }
                    {transactionData && includeReceipt &&
                        <Fragment>
                            <DialogSaleReceipt
                                ref={e => (this.printReceiptRef = e)}
                                data={transactionData}
                                payments={paymentsList}
                                products={productList}
                                discounts={discountsList}
                            />
                            <div style={tableStyles.center}>
                                <ReactToPrint
                                    trigger={() =>
                                        <RaisedButton
                                            primary
                                            type="button"
                                            label="Print Receipt"
                                            style={tableStyles.printBtnCenter}/>
                                    }
                                    content={() => this.printReceiptRef}
                                />
                            </div>
                        </Fragment>
                    }
                </Dialog>
                <div ref={(ref) => this.detailPosition = ref}>
                </div>
            </div>
        )
    }
}

SalesLogDialog.propTypes = {
    addField: PropTypes.bool,
    includeReceipt: PropTypes.bool,
    offset: PropTypes.string.isRequired,
    onCloseDialog: PropTypes.func,
    sequence: PropTypes.string
};

SalesLogDialog.defaultProps = {
    addField: true,
    includeReceipt: true,
    offset: null,
    sequence: null
};

const enhance = compose(
    connect()
);

export default enhance(SalesLogDialog);



// WEBPACK FOOTER //
// ./src/Fuse/components/SalesLogDialog.js